var ko = require('knockout');
var $ = require('jquery');

ko.components.register('checkout-overview-page', {
  viewModel: require('./checkout-overview-page'),
  template: require('./checkout-overview-page.template')
});

$('[data-checkout-overview-page]').each(function() {
  ko.applyBindings({}, this);
});
